/*
* Created on Mar 22, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useState} from 'react';

const SubmitButtonComponent = ({text, onSubmit, input, setInput, initial_state=false, preSubmit}) => {
    const [disable, setDisable] = useState(initial_state);

    const validateInput = () => {
        if (preSubmit && typeof preSubmit === 'function') {
            return preSubmit(input);
        }
        else {
            for (const [key, value] of Object.entries(input) ) {
                if (value.error?.length > 0) {
                    return false;
                }

                if (value.required && (!value.value || value.value?.length <= 0)) {
                    return false;
                }
            }
            return true;
        }

    }

    useEffect(()=>{
        if (input) {
            setDisable(!validateInput());
        }
    },[input]);

    return (
        <button type="button"
                disabled={disable}
                className="q-btn q-btn-primary"
                onClick={async () => await onSubmit(setDisable)}
        >{text}
        </button>
    );
};

export default SubmitButtonComponent;